import { setWith, get, union } from 'lodash-es';

export default {
  data() {
    return {
      initialDynamicFieldPropsSnapshot: undefined,
    };
  },
  methods: {
    validateOnlyTouchedFields() {
      this.fields.forEach(field => field.touched && field.validate());
    },
    captureInitialDynamicFieldState(currentFields) {
      this.initialDynamicFieldPropsSnapshot = currentFields
        .filter(f => f.dynamic)
        .map(f => f.prop)
        .sort();
    },
    resetInitialValue() {
      if (!Array.isArray(this.fields)) {
        return;
      }

      this.fields.forEach((field) => {
        field.resetInitialValue();
      });

      this.captureInitialDynamicFieldState(this.fields);
    }
  },
  computed: {
    currentDynamicSortedFieldProps() {
      if (this.fields && Array.isArray(this.fields)) {
        return this.fields
          .filter(f => f.dynamic)
          .map(f => f.prop)
          .sort();
      }
      return [];
    },
    hasDynamicStructureChanged() {
      if (this.initialDynamicFieldPropsSnapshot === undefined) {
        return false;
      }

      const currentDynamicProps = this.currentDynamicSortedFieldProps;
      const initialDynamicProps = this.initialDynamicFieldPropsSnapshot;

      if (currentDynamicProps.length !== initialDynamicProps.length) {
        return true;
      }

      for (let i = 0; i < currentDynamicProps.length; i++) {
        if (currentDynamicProps[i] !== initialDynamicProps[i]) {
          return true;
        }
      }
      return false;
    },
    dirty() {
      return this.fields.filter(it => it.dirty).length > 0 || this.hasDynamicStructureChanged;
    },
    validationFieldsErrors() {
      return this.fields?.reduce((result, { errorMessage, prop }) => {
        const path = prop.split('.').slice(0, 2);
        const error = get(result, path, []);
        const errorMessages = errorMessage && errorMessage.length ? union(error, [errorMessage]) : error;
        setWith(result, path, errorMessages, Object);
        return result;
      }, {}) || {};
    },
    fieldsList() {
      return this.fields?.reduce((result, acc) => {
        result[acc.prop] = acc;
        return result;
      }, {}) || {};
    }
  },
  watch: {
    fields: {
      handler(newFields) {
        const hasDynamicFieldsInUpdate = newFields && Array.isArray(newFields) && newFields.some(f => f.dynamic);

        if (this.initialDynamicFieldPropsSnapshot === undefined && hasDynamicFieldsInUpdate) {
          this.captureInitialDynamicFieldState(newFields);
        }
      },
      immediate: true,
      deep: true
    }
  }
};
